import React, { useMemo, useState } from "react";
import { Input } from "@progress/kendo-react-inputs";
import { Label } from "@progress/kendo-react-labels";
import { Button } from "@progress/kendo-react-buttons";
import SectionDivider, {
  SectionDividerFull,
} from "components/Contact/sectionDivider";
import styles from "../../Settings.module.scss";
import DocuSignLogo from "../../../../assets/Settings/Integrations/DocuSignLogo.png";

export default function DocuSignPage({ connectionStatus, onClose }) {
  const [integrationKey, setIntegrationKey] = useState("");
  const [secretKey, setSecretKey] = useState("");
  const [apiUrl, setApiUrl] = useState("");
  const [authUri, setAuthUri] = useState("");

  return (
    <div className={`d-flex flex-column w-100 align-items-start px-5 py-2 `}>
      <div className="d-flex align-items-center mb-4 w-100">
        <div className="ms-2 me-4">
          <img
            src={DocuSignLogo}
            alt="DocuSign"
            style={{
              height: "36px",
              width: "36px",
            }}
          />
        </div>

        <div className="flex-grow-1">
          <SectionDivider
            sectionName="DocuSign Verification System"
            auto
            wrap={false}
          />
        </div>
      </div>

      <div className="gap-3 d-flex flex-column px-4 w-100">
        <div className="d-flex align-items-center">
          <Label style={{ width: 125 }}>Integration Key</Label>
          <Input
            value={integrationKey}
            onChange={(e) => setIntegrationKey(e.value)}
            style={{ width: 360 }}
          />
        </div>
        <div className="d-flex align-items-center">
          <Label style={{ width: 125 }}>Secret Key</Label>
          <Input
            value={secretKey}
            onChange={(e) => setSecretKey(e.value)}
            style={{ width: 360 }}
          />
        </div>
        <div className="d-flex align-items-center">
          <Label style={{ width: 125 }}>Auth URL</Label>
          <Input
            value={authUri}
            onChange={(e) => setAuthUri(e.value)}
            style={{ width: 360 }}
          />
        </div>
        <div className="d-flex align-items-center">
          <Label style={{ width: 125 }}>API URL</Label>
          <Input
            value={apiUrl}
            onChange={(e) => setApiUrl(e.value)}
            style={{ width: 360 }}
          />
        </div>
        <div className="mt-4 mb-3">
          <h3 className="fs-md fw-bold">DocuSign Settings</h3>
          <SectionDividerFull rowClassName="mt-3 mb-4" />
          <div className="d-flex align-items-baseline small mb-1">
            <span
              className="fw-semibold"
              style={{ width: 150, whiteSpace: "nowrap" }}
            >
              Redirect URL:
            </span>
            <span className="text-muted">https://app.linq.legal</span>
          </div>
          <div className="d-flex align-items-baseline small">
            <span
              className="fw-semibold"
              style={{ width: 150, whiteSpace: "nowrap" }}
            >
              CORS origin URL:
            </span>
            <span className="text-muted">https://app.linq.legal</span>
          </div>
        </div>

        <div>
          <Button className="common-btn me-2">Connect DocuSign</Button>
        </div>
      </div>
    </div>
  );
}
